(function () {
  var loaded = false;
 
  function loadPostHog() {
    if (loaded) return;
    loaded = true;
 
    if (window.posthog && typeof window.posthog.init === 'function') {
        posthog.init('phc_vYYZBMTuW8rUwyEYfjGqtGbMet3Kw7MgRVjw2d2xXXWq', {
            api_host: 'https://eu.i.posthog.com',
            defaults: '2026-05-30',
            person_profiles: 'identified_only', // or 'always' to create profiles for anonymous users as well
        })
    }
  }
 
  function checkAndLoad() {
    if (window.Shopify.customerPrivacy.analyticsProcessingAllowed()) {
      loadPostHog();
    }
  }
 
  // Consent beschikbaar bij laden
  if (window.Shopify?.customerPrivacy) {
    checkAndLoad();
  } else {
    document.addEventListener('cargoodsConsentReady', function(event) {
      checkAndLoad();
    });
  }
  
  // Consent-update (gebruiker handelt banner later af)
  document.addEventListener('visitorConsentCollected', function(event) {
    checkAndLoad();
  });

})();

// Event-listener for add-to-carts
document.addEventListener('submit', function(event) {
  const form = event.target;
  if (form.getAttribute('data-type') !== 'add-to-cart-form') return;
  if (!window.posthog) return;
  
  const variantId = form.querySelector('input[name="id"][ref="variantId"]')?.value;
  const productTitle = form.querySelector('input[name="title"][ref="variantTitle"]')?.value;

  posthog.capture('add_to_cart', {
    product_title: productTitle,
    variant_id: variantId,
    url: window.location.href,
    $feature_flag: 'pdp-price-delivery-presentation',
    $feature_flag_response: posthog.getFeatureFlag('pdp-price-delivery-presentation')
  });
});

// toggle event bubbelt niet, dus useCapture: true
document.addEventListener('toggle', function(e) {
  if (e.target.tagName !== 'DETAILS') return;
  if (!window.location.pathname.includes('/products/')) return;
  if (!window.posthog) return;

  // Alleen meten bij openen, niet bij sluiten
  if (e.target.open) {
    var summary = e.target.querySelector('summary');
    posthog.capture('faq_opened', {
      question: summary ? summary.innerText.trim() : null,
      url: window.location.href
    });
  }
}, true);